import { render } from "./TopBar.vue?vue&type=template&id=4aa0f34c&scoped=true"
import script from "./TopBar.vue?vue&type=script&lang=js"
export * from "./TopBar.vue?vue&type=script&lang=js"

import "./TopBar.vue?vue&type=style&index=0&id=4aa0f34c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4aa0f34c"

export default script